import React from 'react'
import { config } from '../../../config/config'

const Playstore = ({ information }) => {
    return (
        <a href={information.provider.urlGoogle} className="flex justify-end basis-[48.5%] h-[40px]" rel="noreferrer" target={'_blank'}>
            <img
                id={config.content.provider_popup.playstore.id}
                alt={config.content.provider_popup.playstore.alt}
                className='h-full self-end'
            />
        </a>
    )
}

export default Playstore
